import { PartiallyRequired } from '@thyme/libs/src/typing/partial'
import { Timestamps } from '@/api/global/types/timestamps'
import { Direction, SpeakingWithType } from './shared'

// TYPES --------------------
export type CallDisposition = {
  callDispositionId?: string
  communicationId: string
  direction: Direction
  disposition: string
  isIdentityVerified: boolean
  usedTranslator: boolean
  speakingWithPersonId: string | null // this is an Entity id, not a Person id
  speakingWithType: SpeakingWithType | null
} & Timestamps

export type DirtyCallDisposition = PartiallyRequired<
  CallDisposition,
  'communicationId' | 'disposition' | 'direction'
>

export type CreateCallDisposition = Omit<
  DirtyCallDisposition,
  'communicationId'
>

// CONSTANTS --------------------
export const callDispositionDisplayLookup = {
  ANSWERED: 'Answered',
  ANSWERED_REQUESTED_CALLBACK: 'Answered - Requested Callback',
  LEFT_VOICEMAIL: 'Left Voicemail',
  VOICEMAIL_FULL: 'Voicemail Full',
  NUMBER_INOPERABLE: 'Number Inoperable',
  WRONG_NUMBER: 'Wrong Number',
  NO_ANSWER: 'Did Not Answer - No Voicemail',
  CONNECTIVITY_ISSUES: 'Connectivity Issues',
  DO_NOT_CALL_LIST: 'Do Not Call List',
  MEMBER_HUNG_UP: 'Member Hung Up',
} as { [key: string]: string }

export const callTypeDisplayLookup = {
  inbound: 'Inbound Call from',
  outbound: 'Outbound Call from',
  plannedCall: 'Scheduled Call to',
  text: 'Text conversation',
} as { [key: string]: string }

export const callTypeDisplayLookupV2 = {
  inbound: 'Inbound Call from',
  outbound: 'Outbound Call to',
  plannedCall: 'Scheduled Call to',
  text: 'Text Conversation',
} as { [key: string]: string }
